<h2 mat-dialog-title>Track playlists</h2>
<mat-dialog-content>

  <div class="admin-input-select">
    <mat-label>Playlists</mat-label>
    <mat-chip-grid #genreSelectorGrid aria-label="Genre selection">
      @for (option of playlists(); track option) {
        <mat-chip-row (removed)="remove(option)">
          {{option.name}}
          <button matChipRemove [attr.aria-label]="'remove ' + option.id">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <div class="select-input-field">
      <input
        placeholder="Select Playlist"
        #genreInput
        [(ngModel)]="currentPlaylist"
        [matChipInputFor]="genreSelectorGrid"
        [matAutocomplete]="artistSelector"
      />
      <mat-autocomplete #artistSelector="matAutocomplete" (optionSelected)="selected($event); genreInput.value = ''" [displayWith]="displayStateName">
        @for (option of availableOptions; track option) {
          <mat-option [value]="option">{{option.name}}</mat-option>
        }
      </mat-autocomplete>
    </div>

  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
  <button matButton (click)="save()" cdkFocusInitial>Save</button>
</mat-dialog-actions>
